<template>
  <div>
    <shortcut></shortcut>
    <div class="new_content">
      <!--证书查询模块开始-->
      <div class="new_zhengshu_main" style="border:1px solid #eaeefb;border-radius:4px;transition:.2s; padding: 50px 200px; margin-top: 40px;">
        <div style="min-height:200px;">
          <!--<ul>-->
          <!--<li><span class="zi">证书编号：</span><span class="tian"><input v-model.trim="certificatNo" type="text"-->
          <!--class="shu"/></span></li>-->
          <!--<li><span class="zi">姓　　名：</span><span class="tian"><input v-model.trim="userName" type="text" class="shu"/></span>-->
          <!--</li>-->
          <!--</ul>-->
          <el-form  ref="form" :model="formData" :rules="rules">
            <el-form-item label="证书编号：" prop="certificatNo">
              <el-input v-model="formData.certificatNo"></el-input>
            </el-form-item>
            <el-form-item label="姓　　名：" prop="userName">
              <el-input v-model="formData.userName"></el-input>
            </el-form-item>
          </el-form>
          <!--<a  class="liji" @click="query" >查 询</a>-->
          <el-button type="primary" :loading="buttonLoading" @click="query" style="width:60%; margin: 0 auto; display: block;">查询</el-button>
        </div>
      </div>
      <!--证书查询模块结束-->
    </div>
    <footer1></footer1>


    <el-dialog
      title="证书信息"
      :visible.sync="dialogVisible"
      width="90%">
      <div class="new_zhengshu_main">
        <ul id="zhengshu_jieguo_ul" style="padding: 30px; padding-left: 10%;">
          <li style="height:30px; line-height:30px; margin-bottom:10px;"><span class="zi">姓　　名：</span><span class="tian" style="color:#333;">{{certificatInfo.realName}}</span>
          </li>
          <li style="height:30px; line-height:30px; margin-bottom:10px;"><span class="zi">所在单位：</span><span class="tian" style="color:#333;">{{certificatInfo.organizationName}}</span>
          </li>
          <li style="height:30px; line-height:30px; margin-bottom:10px;"><span class="zi">所在科室：</span><span class="tian" style="color:#333;">{{certificatInfo.keShi}}</span>
          </li>
          <li style="height:30px; line-height:30px; margin-bottom:10px;"><span class="zi">证书编号：</span><span class="tian" style="color:#333;">{{certificatInfo.certificateNo}}</span>
          </li>
          <li style="height:30px; line-height:30px; margin-bottom:10px;"><span class="zi">项目名称：</span><span class="tian"  style="color:#333;">{{certificatInfo.name}}</span>
          </li>
          <li style="height:30px; line-height:30px; margin-bottom:10px;"><span class="zi">项目类别：</span><span class="tian" style="color:#333;">{{certificatInfo.projectType}}</span>
          </li>
          <li style="height:30px; line-height:30px; margin-bottom:10px;"><span class="zi">学分类别：</span><span class="tian"  style="color:#333;">{{certificatInfo.creditType}}</span>
          </li>
          <li style="height:30px; line-height:30px; margin-bottom:10px;"><span class="zi">授予学分：</span><span class="tian"  style="color:#333;">{{certificatInfo.credit}}</span>
          </li>
          <li style="height:30px; line-height:30px; margin-bottom:10px;"><span class="zi">授分日期：</span><span class="tian"  style="color:#333;">{{certificatInfo.creaditDate}}</span>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import  shortcut from '../components/Shortcut'
  import  footer1 from '../components/Footer1'
  import {getCertificate} from '../api/api';
  export default {
    components: {
      shortcut,
      footer1
    },
    data () {
      return {
        dialogVisible: false,
        certificatInfo: {},
        formData: {
          certificatNo: "",
          userName: "",
        },
        rules: {
          certificatNo: [
            {required: true, message: '请输入证书编号', trigger: 'blur'}
          ],
          userName: [
            {required: true, message: '请选择姓名', trigger: 'blur'}
          ]
        },
        buttonLoading: false
      }
    },
    mounted () {
    },
    computed: {},
    methods: {
      query() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.buttonLoading = true
            getCertificate({
              number: this.formData.certificatNo,
              name: this.formData.userName
            }).then((response) => {
              let data = response.data
              if (data.state == "exist") {
                this.certificatInfo = data.info
                this.buttonLoading = false
                this.dialogVisible = true
              } else {
                this.$message({
                  message: data.info,
                  type: 'warning'
                });
              }
              this.buttonLoading = false
            })
          } else {
            this.$message({
              message: '证书编号或姓名不可为空',
              type: 'warning'
            });
            return false;
          }
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/CertificateQuery.vue